/**
 * This is the type for the ABAP SPRAS language type (language key)
 */
export enum LanguageSprasType {
  D = "German",
  E = "English",
  J = "Japanese",
}
